import React from 'react';

export default function Error(props) {
  return (
    <div className="invalid-feedback d-block mt-0 mb-2">
      {props.error && props.error.message.errors && (
        <>
          {props.error.message.errors[0]}
          <br />
        </>
      )}
      {props.error && !props.error.message.errors && props.error.message && (
        <>
          {props.error.message}
          <br />
        </>
      )}
    </div>
  );
}
